import {createApp} from 'vue'
import axios from 'axios'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import {loadFonts} from './plugins/webfontloader'

// PrimeVue styles
import "primevue/resources/themes/saga-blue/theme.css"; //theme
import "primevue/resources/primevue.min.css"; //core CSS
import "primeicons/primeicons.css"; //icons

// VPhoneInput styles
import 'flag-icons/css/flag-icons.min.css';
import 'v-phone-input/dist/v-phone-input.css';

import { VAutocomplete } from 'vuetify/components';

loadFonts()

const app = createApp(App);

console.log(process.env)

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;  // the FastAPI backend

await store.dispatch('logIn');

axios.interceptors.response.use(undefined, function (error) {
  if (error) {
    const originalRequest = error.config;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      store.dispatch('logOut');
      return router.push({name: 'Dashboard'})
    }
    return Promise.reject(error);
  }
});

// IMPORTANT: required when treeshaking Vuetify components.
app.component('VAutocomplete', VAutocomplete);

app.use(router);
app.use(store);
app.use(vuetify);
app.mount("#app");
